module.exports = __webpack_public_path__ + "img/67b00ba19eb09055628ed6f7a003cd9f.39cab813.jpg";